import * as actions from "./actions";
import { rootRef, storageRef } from "../../config/firebase";

function documentacionAColegio(idColegio) {
  return actions.ponerColegioSeleccionado(idColegio);
}

function limpiarColegioSeleccionado() {
  return actions.limpiarColegioSeleccionado();
}

function obtenerDetalleColegio(idColegio) {
  return dispatch =>
    rootRef.child(`detalles/colegios/${idColegio}`).once("value", snap => {
      const { id, nombre, poblacion, provincia } = snap.val();
      dispatch(actions.detalleColegio({ id, nombre, poblacion, provincia }));
    });
}

function resetDetalleColegio() {
  return actions.resetDetalleColegio();
}

function obtenerListaResguardos(idColegio) {
  return dispatch =>
    rootRef
      .child(`escuelas/verano2018/preinscripciones_resguardos/${idColegio}`)
      .once("value", snap => {
        const resguardos = snap.hasChildren() ? Object.values(snap.val()) : [];

        dispatch(actions.listaResguardos(resguardos));
      });
}

function cargarDatosColegio(idColegio) {
  return dispatch => {
    dispatch(obtenerDetalleColegio(idColegio));
    dispatch(obtenerListaResguardos(idColegio));
  };
}

function uploadFile({ file, resguardo, idColegio, confirmada }) {
  return dispatch => {
    const tarea = storageRef
      .child(`verano2018/${idColegio}/${resguardo}/${file.name}`)
      .put(file);
    tarea.on(
      "state_changed",
      snap =>
        dispatch(
          actions.procesoEnvio((snap.bytesTransferred / snap.totalBytes) * 100)
        ),
      error =>
        dispatch(
          actions.uploadComplete(`Se ha producido un error.
        Póngase en contacto con Aristas Educación, S.L. indicando el siguiente código de error:
         <${error.code_}>`)
        ),
      () => {
        dispatch(actions.resetProcesoEnvio());
        dispatch(actions.uploadComplete("Se ha completado el envío"));
        tarea.snapshot.ref.getDownloadURL().then(url => {
          const status = confirmada ? "inscripciones" : "preinscripciones";
          const ruta = `escuelas/verano2018/${status}/${idColegio}/${resguardo}`;
          const idAdjunto = rootRef.child(ruta).push().key;
          let insert = {};
          insert[`${ruta}/adjuntos/${idAdjunto}/url`] = `${url}`;
          insert[`${ruta}/adjuntos/${idAdjunto}/fileName`] = `${file.name}`;
          rootRef.update(insert);
        });
      }
    );
  };
}

function clearUploadComplete() {
  return actions.clearUploadComplete();
}

function borrarAdjunto({
  fileName,
  idAdjunto,
  idColegio,
  idInscripcion,
  confirmada
}) {
  const status = confirmada ? "inscripciones" : "preinscripciones";
  const escuelas = `escuelas/verano2018/${status}`;
  const idRuta = `${idColegio}/${idInscripcion}`;

  return dispatch =>
    storageRef
      .child(`verano2018/${idColegio}/${idInscripcion}/${fileName}`)
      .delete()
      .then(() => {
        rootRef.child(`${escuelas}/${idRuta}/adjuntos/${idAdjunto}`).remove();
      })
      .catch(error => console.log(error));
}

/*---*/
export {
  documentacionAColegio,
  limpiarColegioSeleccionado,
  resetDetalleColegio,
  cargarDatosColegio,
  uploadFile,
  clearUploadComplete,
  borrarAdjunto
};



// WEBPACK FOOTER //
// ./src/ducks/documentacion/operations.js